<template>
  <div class="w-full">
    <div class="px-5 py-3">
      <div
        class="py-3.5 px-5 flex items-center border border-primary rounded-lg bg-root-12"
      >
        <warning-icon-2 size="h-5 w-5" />
        <p class="text-sm font-normal text-primary ml-3">
          Rates are updated every 30 minutes
        </p>
      </div>
      <div class="mt-4">
        <el-form>
          <el-form-item class="">
            <el-input class="w-full" v-model="search" placeholder="Search">
              <i
                slot="prefix"
                :size="20"
                class="el-input__icon el-icon-search"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="grid grid-cols-6 items-center my-5">
        <p
          class="text-13px font-medium flex justify-center text-root-12 col-span-2"
        >
          Source
        </p>
        <p
          class="text-13px font-medium flex justify-center text-root-12 col-span-2"
        >
          Destination
        </p>
        <p
          class="text-13px font-medium flex justify-center text-root-12 col-span-2"
        >
          Rate
        </p>
      </div>
      <div style="height: 50vh" class="w-full overflow-y-scroll">
        <div
          class="mt-6 cursor-pointer"
          v-for="(rateInfo, index) in filterRates"
          :key="index"
        >
          <div
            @click="selectCurrencyPair(rateInfo.from, rateInfo.to)"
            class="p-5 border br-root-2 rounded-lg :hover:opacity-80 items-center justify-center grid grid-cols-6 mb-4"
          >
            <div
              class="flex items-center justify-center md:gap-x-3 gap-x-2 col-span-2"
            >
              <currency-icons :currency="getCurrencyCountry(rateInfo.from)" />
              <p class="text-sm font-bold text-root-4">{{ rateInfo.from }}</p>
            </div>
            <div
              class="flex items-center justify-center md:gap-x-3 gap-x-2 col-span-2"
            >
              <currency-icons :currency="getCurrencyCountry(rateInfo.to)" />
              <p class="text-sm font-bold text-root-4">{{ rateInfo.to }}</p>
            </div>
            <div class="flex justify-center col-span-2 ml-4 items-center">
              <p class="text-sm font-bold text-root-4">
                {{ rateInfo.exchange_rate }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="absolute w-11/12 bottom-2 left-1 right-1 mx-auto">
        <button
          class="w-full text-white bg-primary py-4 rounded-lg font-medium flex items-center justify-center"
          @click="goToTerminal"
          :disabled="!hasDepositAccess"
        >
          Make transfer
          <arrow-right-icon
            fill="black"
            useType="makeTransfer"
            class="ml-5 mt-0.5"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { GetCurrencyCountry } from '@/utils/helpers.js'
import { FIAT, COUNTRIES } from '@/utils/constants.js'
import currencyUpdates from '@/mixins/currencyUpdates.js'
import tenant from '@/mixins/tenant.js'
import userKinds from '@/mixins/userKinds.js'

export default {
  mixins: [currencyUpdates, tenant, userKinds],
  data () {
    return {
      search: '',
      loading: false,
      payload: {
        fromCurrency: 'NGN',
        toCurrency: 'USD',
        page: 1,
        size: 5
      }
    }
  },
  methods: {
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    async selectCurrencyPair (from, to) {
      this.payload.fromCurrency = from
      this.payload.toCurrency = to
      this.$emit('closeDrawer')
      await this.getCurrencyUpdates()
    },
    goToTerminal () {
      this.$router.push('/terminal')
    }
  },
  components: {
    WarningIcon2: () => import('@/assets/icons/WarningIcon2.vue'),
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    ArrowRightIcon: () => import('@/assets/icons/ArrowRightIcon.vue')
  },
  computed: {
    filterRates () {
      const fiats = FIAT.map((fiat) => fiat.currency)
      const countries = COUNTRIES.map((country) => country.currency)
      const fiatOnly = this.exchangeRateData.filter(
        (rateInfo) =>
          fiats.includes(rateInfo.from) && fiats.includes(rateInfo.to)
      )
      const allCountries = this.exchangeRateData.filter(
        (rateInfo) =>
          countries.includes(rateInfo.from) && fiats.includes(rateInfo.to)
      )
      const portfolios = !this.tenantPermission('asset-access')
        ? fiatOnly
        : allCountries
      if (this.search) {
        const filterSearch = portfolios.filter(
          (rateInfo) =>
            rateInfo.from.toLowerCase().includes(this.search.toLowerCase()) ||
            rateInfo.to.toLowerCase().includes(this.search.toLowerCase())
        )
        return filterSearch
      } else {
        return portfolios
      }
    },
    exchangeRateData () {
      return this.$store.state.auth.transferDetails
    }
  }
}
</script>

<style scoped>
>>> .el-input--prefix .el-input__inner {
  border: 1px solid var(--border-1);
  border-radius: 8px;
  background: var(--background-10);
}
.blue-background {
  background: rgba(208, 227, 252, 0.2);
}
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
